import 'config/componentsCore/modal.css';

import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Button, Text, View } from '@coinscrap/webapp-core';

import InputLabel from 'components/InputLabel/InputLabel';

import { ValidateSpanishID } from 'helpers/dni';

import { CONFIG } from '../../config/config';
import { MainButton } from '../MainButton/MainButton';
import { SpanCurrency } from '../SpanCurrency/SpanCurrency';
import * as S from './styles';

const BeneficiaryForm = ({ close, beneficiaries, setBeneficiaries, beneficiary = undefined }) => {
	const [selectedBeneficiary, setSelectedBeneficiary] = useState(beneficiary);
	useEffect(() => {
		console.log('selectedBeneficiary', beneficiary);
		setSelectedBeneficiary(beneficiary);
	}, [beneficiary]);

	const [percentageInput, setPercentageInput] = useState(
		selectedBeneficiary?.percentage ? selectedBeneficiary.percentage : '',
	);

	const [totalPercentage, setTotalPercentage] = useState(0);

	useEffect(() => {
		const newTotalPercentage = beneficiary
			? beneficiaries.reduce(function (acc, ben) {
				return acc + ben.percentage;
			}, 0) - beneficiary.percentage
			: beneficiaries.reduce(function (acc, ben) {
				return acc + ben.percentage;
			}, 0);
		console.log('totalPercentage', newTotalPercentage);
		setTotalPercentage(newTotalPercentage);
	}, [beneficiary, beneficiaries]);

	const [availablePercentage, setAvailablePercentage] = useState(100 - totalPercentage);
	useEffect(() => {
		setAvailablePercentage(100 - totalPercentage);
	}, [totalPercentage, selectedBeneficiary]);

	const [benToEdit, setBenToEdit] = useState(-1);

	// CHECKS
	const [isValidDNI, setIsValidDNI] = useState(true);
	const [invalidDNIreason, setInvalidDNIreason] = useState('Documento inválido');
	const [isValidPercentage, setIsValidPercentage] = useState(true);

	useEffect(() => {
		console.log('availablePercentage', availablePercentage, totalPercentage);
		if (availablePercentage + totalPercentage > 100) {
			setIsValidPercentage(false);
		} else {
			setIsValidPercentage(true);
		}
	}, [availablePercentage, totalPercentage]);

	const [inputWidth, setInputWidth] = useState(2);

	useEffect(() => {
		const findPeriodsAndDecimals = [...percentageInput.toString()].filter(
			(item) => item === '.' || item === ',',
		);
		const width =
			percentageInput === ''
				? '20'
				: percentageInput.toString().trim().length +
				1 +
				findPeriodsAndDecimals.length * -0.6;
		setInputWidth(width);
		return () => { };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [percentageInput]);

	const { t } = useTranslation();

	const isDisabled = () => {
		return (
			!selectedBeneficiary?.name ||
			!selectedBeneficiary?.surname ||
			!selectedBeneficiary?.dni ||
			!selectedBeneficiary?.percentage ||
			!isValidDNI ||
			!isValidPercentage
		);
	};

	const noAnyadido = (dni) => {
		if (beneficiary === undefined && beneficiaries.some((ben) => ben.dni === dni)) {
			setInvalidDNIreason('El documento ya ha sido añadido a la lista de beneficiarios.');
			return false;
		}
		return true;
	};

	useEffect(() => {
		if (selectedBeneficiary) {
			let benAmodificar = beneficiaries.find((ben) => ben.dni === selectedBeneficiary.dni);
			setBenToEdit(beneficiaries.indexOf(benAmodificar));
		}

		return () => { };
	}, [beneficiaries, selectedBeneficiary]);

	return (
		<View alignItemsStartSt>
			<View inputRowSt style={{ width: isMobile ? '100%' : undefined }}>
				<InputLabel
					value={selectedBeneficiary?.name || ''}
					onChange={(e) => {
						setSelectedBeneficiary({ ...selectedBeneficiary, name: e.target.value });
					}}
					label={t('clientData.beneficiaryModal.inputName')}
					style={{
						marginTop: -20,
						maxWidth: isMobile ? 'none' : 300,
					}}
				/>
				<InputLabel
					value={selectedBeneficiary?.surname || ''}
					onChange={(e) => {
						setSelectedBeneficiary({ ...selectedBeneficiary, surname: e.target.value });
					}}
					label={t('clientData.beneficiaryModal.inputSurname')}
					style={{
						marginTop: -20,
						maxWidth: isMobile ? 'none' : 300,
					}}
				/>
			</View>
			<View inputRowSt style={{ width: isMobile ? '100%' : undefined }}>
				<InputLabel
					disabled={beneficiary !== undefined}
					value={selectedBeneficiary?.dni || ''}
					onBlur={() => {
						setInvalidDNIreason('Documento inválido');
						setIsValidDNI(
							selectedBeneficiary?.dni
								? ValidateSpanishID(selectedBeneficiary.dni).valid &&
								noAnyadido(selectedBeneficiary?.dni)
								: false,
						);
					}}
					onChange={(e) => {
						if (!isValidDNI) {
							setInvalidDNIreason('Documento inválido');
							setIsValidDNI(
								e.target.value === ''
									? false
									: ValidateSpanishID(e.target.value).valid &&
									noAnyadido(e.target.value),
							);
						}
						setSelectedBeneficiary({ ...selectedBeneficiary, dni: e.target.value });
					}}
					label={t('clientData.beneficiaryModal.inputDNI')}
					errorMsg={!isValidDNI && invalidDNIreason}
					style={{
						marginTop: -20,
						maxWidth: isMobile ? 'none' : 300,
					}}
				/>
				<S.SpecialInputLabelWrapper
					style={{
						marginTop: -20,
						maxWidth: isMobile ? 'none' : 300,
					}}
				>
					<View rowSt justifyStartSt>
						<Text labelInputSt>Porcentaje</Text>
					</View>
					<S.SpecialInputWrapper>
						<S.SpecialInput
							width={inputWidth + 'ch'}
							placeholder={'Porcentaje'}
							value={percentageInput ?? ''}
							onChange={(e) => {
								setIsValidPercentage(
									e.target.value === '' ||
									(parseFloat(e.target.value) <= availablePercentage &&
										e.target.value > 0),
								);
								if (e.target.value === '') {
									setSelectedBeneficiary({
										...selectedBeneficiary,
										percentage: 0,
									});
									setPercentageInput('');
								} else {
									setSelectedBeneficiary({
										...selectedBeneficiary,
										percentage: e.target.value.replace(/\D/g, ''),
									});
									setPercentageInput(e.target.value.replace(/\D/g, ''));
								}
							}}
						></S.SpecialInput>
						<SpanCurrency>{percentageInput !== '' ? `%` : ''}</SpanCurrency>
					</S.SpecialInputWrapper>

					{!isValidPercentage && (
						<Text errorSt smSt leftSt style={{ marginTop: 10 }}>
							{`Máximo asignable: ${availablePercentage} %`}
						</Text>
					)}
				</S.SpecialInputLabelWrapper>

				<View
					style={{
						marginTop: -20,
						maxWidth: isMobile ? 'none' : 300,
					}}
				>
					<View rowSt justifyStartSt>
						<Text labelInputSt>&nbsp;</Text>
					</View>
					<MainButton
						disabled={isDisabled()}
						onClick={() => {
							const newBen = {
								source: 'designed',
								name: selectedBeneficiary.name,
								surname: selectedBeneficiary.surname,
								dni: selectedBeneficiary.dni,
								percentage: parseFloat(selectedBeneficiary?.percentage),
							};
							if (beneficiary) {
								beneficiaries[benToEdit] = newBen;
							} else {
								beneficiaries.push(newBen);
							}
							setBeneficiaries(beneficiaries);
							close();
						}}
						style={{
							width: '100%',
							padding: `calc(${CONFIG.inputs.padding.default} - 0px)`,
							disabled: isDisabled(),
						}}
					>
						{beneficiary ? 'MODIFICAR' : 'AÑADIR'}
					</MainButton>
				</View>
			</View>
		</View>
	);
};

export default BeneficiaryForm;
